export const zhDefaultTranslations: Record<string, string> = {
  menu: '主页',
  back: '返回',
  messages: '信息',
  cart: '购物车',
  settings: '设置',
  subtitles: '字幕',
  turn_off_subtitles: '关闭',
  no_subtitles_available: '无可用字幕',
  off: '关闭',
  original: '查看翻译',
  translated: '查看但不带翻译',
  download_update: '请稍候。<br/>正在下载更新…',
  download_retry: '重试',
  download_cancel: '取消',
  download_available: '有新的更新可用。 是否立即下载？',
  auth_sent: '授权请求已发送。请等待确认…',
  auth_pending: '授权请求正在待决…',
  auth_rejected: '授权请求已被拒绝',
  request_confirmed: '请求已确认。 请求编号',
  order_confirmed: '订单已确认。 订单编号',
  internet_required: '要求连接互联网',

  openexturl: '在浏览器中打开 URL？',

  messages_send: '发送',

  bill_page: '查看账单',
  bill_total: '合计',
  bill_requesting: '正在请求账单',
  bill_error: '数据不可用',
  bill_checkedout: '客人已退房',
  bill_loginreq: '要求授权',

  feedback_sent: '您的表单已发送。 非常感谢您填写。',
  feedback_invalidfeedback: '该投票不存在',
  feedback_alreadyanswered: '该表单已填写。 非常感谢。',

  select_none: '无',
  newmessage: '新消息',

  shop_add_comment: '您是否有其他要求？',

  tv_television: '电视',
  tv_nottelevision: '信息',
  tv_room: '房间号',
  tv_welcome: '欢迎，',
  tv_allchannels: '所有频道',
  tv_categories: '类别',
  tv_category: '类别',
  tv_back: '返回',

  dooreye_ask_title: '电子猫眼',
  dooreye_ask_text: '您好，门外有访客',
  dooreye_ask_confirm: '确认',
  dooreye_ask_cancel: '取消',
  dooreye_show_error: '请检查猫眼与电视的视频信号线连接',
  fullscreen_language_btn: 'Language',
};
